var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21252_38163)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_21252_38163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46489 16.837C0.986201 14.1222 2.9265 11.5108 5.79866 11.0044L37.0018 5.50244C39.8739 4.996 42.5904 6.78623 43.069 9.50103L46.536 29.1633C47.0147 31.8781 45.0744 34.4895 42.2023 34.9959L10.9992 40.4979C8.12699 41.0043 5.41058 39.2141 4.93189 36.4993L1.46489 16.837Z",
    fill: "url(#paint0_linear_21252_38163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8631 15.7241C4.7672 15.1802 5.13037 14.6615 5.67426 14.5656L38.4861 8.77999C39.03 8.68409 39.5487 9.04726 39.6446 9.59115L40.9275 16.867L6.14604 23L4.8631 15.7241Z",
    fill: "#E6E5FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21252_38163",
    x1: 19.0965,
    y1: 18.4955,
    x2: 8.14005,
    y2: 42.0111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A2A0FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21252_38163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_21252_38163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.246,
    height: 42.246,
    fill: "white",
    transform: "translate(-0.469727 5.86597) rotate(-10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.bb5da988724808e9448e30c7fe6a3ba9.svg";
export { ForwardRef as ReactComponent };